<template>
    <div class="modal-card">
        <header class="modal-card-head has-bg-danger">
            <p class="modal-card-title">{{$t('MODALINSERIRNOVAASTEC.AVISO')}}</p>
        </header>
        <section class="modal-card-body is-paddingless">
            <b-notification type="is-warning">
                <h5 class="is-size-5">{{$t('SISTEMA.ATENCAO')}}</h5>                
                <p>{{$t('MODALINSERIRNOVAASTEC.AVISOMENSAGEM')}}</p>
            </b-notification>
          
            <div class="box ">          

                <div class="columns">
                    <div class="column is-6">
                        <searchIdName  :id.sync="clienteId" :codigoExterno="true"
                            :trazDesativado="false" :label="$t('SISTEMA.CLIENTE')" table="Cliente" :camposAdicionais="'&unidadeId='+unidadeId" >
                                <slot>
                                    <b-button icon-left="plus-box"
                                            @click="abrirTelaCadastroCliente()"                                       
                                            :title="$t('MODALINSERIRNOVAASTEC.NOVOCLIENTE')"></b-button>
                                    <b-button v-if="clienteId>0" icon-left="refresh"  @click="confirmarAtualizarClienteEfinance()"                                                      
                                            :title="$t('GUIAATENDIMENTO.ATUALIZARCLIENTE')"></b-button>                                             
                                </slot>                    
                        </searchIdName>                                   
                    </div>

                    <div class="column is-6">
                        <b-field :label="$t('MODALINSERIRNOVAASTEC.TIPOCONTATO')">
                                        <b-select expanded v-model="tipoContato">                                            
                                            <template v-for="(item, index) in tipoContatos">
                                                <option v-bind:key="index" :value="item.valor">
                                                    {{item.descricao}}
                                                </option>
                                            </template>
                                        </b-select>
                                    </b-field>                          
                                                           
                    </div>                     
                </div>
                
                 
                         
                <div v-if="clienteId>0" class="columns">   
                    <div class="column is-6">
                        <b-field :label="$t('MODALINSERIRNOVAASTEC.ENDERECO')">                                  
                            <b-input    :disabled="true" type="text" v-model="endereco"> </b-input>
                        </b-field>                        
                    </div>
                    <div class="column is-6">
                        <b-field :label="$t('MODALINSERIRNOVAASTEC.COMPLEMENTO')">                                  
                            <b-input     :disabled="true" type="text" v-model="complemento"> </b-input>
                        </b-field>                        

                    </div>                    
                </div>

                <div v-if="clienteId>0" class="columns">   
                    <div class="column is-3">
                        <b-field :label="$t('MODALINSERIRNOVAASTEC.BAIRRO')">                                  
                            <b-input  :disabled="true"     type="text" v-model="bairro"> </b-input>
                        </b-field>                        

                    </div>
                    <div class="column is-3">
                        <b-field :label="$t('MODALINSERIRNOVAASTEC.CIDADE')">                                  
                            <b-input  :disabled="true"      type="text" v-model="cidade"> </b-input>
                        </b-field>                        

                    </div>
                    <div class="column is-3">
                        <b-field :label="$t('MODALINSERIRNOVAASTEC.UF')">                                  
                            <b-input   :disabled="true"     type="text" v-model="uf"> </b-input>
                        </b-field>                        

                    </div>
                    <div class="column is-3">
                        <b-field :label="$t('MODALINSERIRNOVAASTEC.CEP')">                                  
                            <b-input  :disabled="true"      type="text" v-model="cep"> </b-input>
                        </b-field>                        

                    </div>                                         
                </div>    
                
                            
                <div v-if="clienteId>0" class="columns">   
                    <div class="column is-6">
                        <b-field :label="$t('MODALINSERIRNOVAASTEC.REFERENCIA')">                                  
                            <b-input     :disabled="true" type="text" v-model="referencia"> </b-input>
                        </b-field>                        
                    </div>
                    <div class="column is-3">
                        <b-field :label="$t('MODALINSERIRNOVAASTEC.TELEFONE')">                                  
                            <b-input      :disabled="true"  type="text" v-model="telefone"> </b-input>
                        </b-field>                        

                    </div>                 
                    <div class="column is-3">
                        <b-field :label="$t('MODALINSERIRNOVAASTEC.EMAIL')">                                  
                            <b-input     :disabled="true"  type="text" v-model="email"> </b-input>
                        </b-field>                        

                    </div>                                        
                </div>           
              
                <div v-if="clienteId>0" class="columns">   
                    <div class="column is-6">
                           
                        <b-field>
                            <b-upload  
                            accept=".pdf,.jpg,.jpeg,.png,.mp4,.mov,.wmv,.PNG,.PDF,.JPG,.JPEG,.MP4,.MOV,.WMV"
                            multiple expanded drag-drop v-model="files" >
                                <section class="section">
                                    <div class="content has-text-centered">
                                        <p>
                                            <b-icon icon="upload" size="is-medium"> </b-icon>
                                        </p>
                                        <p>{{$t('ANEXOS.ARRASTEARQUIVOS')}}</p>
                                        <p>({{$t('ANEXOS.APENASFOTOS')}})</p>
                                    </div>
                                </section>
                            </b-upload>                                          
                        </b-field>
                        <div v-if="files" class="tags">
                            <span v-for="(file, index) in files"
                                :key="index" class="tag is-primary" >
                                {{file.name}}
                                <button class="delete is-small" type="button" @click="deleteFile(index)">
                                </button>
                            </span>                                            
                        </div>                           
                    </div>
                    <div class="column is-6">
                        <b-field :label="$t('SISTEMA.OBSERVACAO')">      
                            <textarea class="textarea" v-model="observacoes" rows="2"></textarea>          
                        </b-field>                                
                    </div>                            

                </div>  

                            
              

            </div> 
    
        </section>
        <footer class="modal-card-foot">
            <b-button  v-if="clienteId>0" type="is-success"
                     :loading="isLoading"
                      @click="confirmar">{{$t('SISTEMA.CONFIRMAR')}}</b-button>
            <b-button @click=" $emit('close'); ">{{$t('SISTEMA.CANCELAR')}}</b-button>
        </footer>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapState } from 'vuex'
    import searchIdName from '@/components/searchIdName.vue'    
    
    export default {

        props: {
            tipoEtapa: String                                                                  
        },        

        data() {
            return {                                                            
                isLoading :false,
                observacoes: null,
                clienteId:null,                            
                endereco: null,
                complemento:null,
                bairro:null,
                cidade:null,
                uf: null,
                cep:null,
                referencia:null,
                telefone:null,
                email:null,
                tipoContato:null,
                files:[],    
                tipoContatos:[]        
            }
        },
        components: {                     
            searchIdName            
        },          
        computed: {
            ...mapState([                                
                'unidadeId',                
            ]),  
        },        
        watch: {
            
            clienteId: function() {                                 
                this.carregarEndereco();

            },                      
        },            

        mounted() {
            this.loadTipoContatos();
        },
        methods: {
            loadTipoContatos(){
                this.$http.get('/api/search/ListarTiposContato')
                .then(res => {
                    if (res.data != null) {
                        this.tipoContatos = res.data
                    }
                })   
            },
                  
            confirmarAtualizarClienteEfinance(){
                
                this.$buefy.dialog.confirm({
                    message: this.$t('GUIAATENDIMENTO.ATUALIZARCLIENTE'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => {                        
                        try {
                            this.isLoading=true;
                            this.$http.get(`/api/integracao/AtualizarClienteElist?clienteId=${this.clienteId}&unidadeId=${this.unidadeId}&codigoExterno=true`)
                            .then((res) => {
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: this.$t('SISTEMA.SALVOSUCESSO'),
                                    type: 'is-success'
                                })
                            }).finally(() => {                                                                
                                this.isLoading = false;                                                                                                                                                                 
                                this.carregarEndereco();
                            });                             
                            
                        } catch (e) {
                            this.isLoading=false;                        
                            console.error(e);
                        }                        
                    },
                    onCancel: () => {                        
                        return true;
                    },
                })
            },               
            carregarEndereco(){

                if(this.clienteId>0){
                    this.isLoading= true;


                    this.$http.get('/api/manutencao/cliente?id=' + this.clienteId+"&codigoExterno=true&unidadeId="+this.unidadeId)
                        .then(res => {
                            this.endereco =  res.data.endereco;
                            this.complemento =  res.data.complemento;
                            this.bairro =  res.data.bairro;
                            this.referencia =  res.data.referencia;
                            this.cidade =  res.data.cidadeNome;
                            this.uf =  res.data.uf;
                            this.cep =  res.data.cep;
                            this.telefone =  res.data.fone;
                            this.email =  res.data.email;

                            
                        }).finally(() => {
                            this.isLoading= false;
                        });
                }else{
                            this.endereco =  null;
                            this.complemento =  null;
                            this.bairro =  null;
                            this.referencia =  null;
                            this.cidade =  null;
                            this.uf =  null;
                            this.cep =  null;
                            this.telefone =  null;
                            this.email =  null;
                }

            },

                 
            deleteFile(index){                
                this.files.splice(index, 1)            
            },            
            abrirTelaCadastroCliente(){
                this.$emit('close');      
                this.$router.push({ name: 'cliente'});                                  
            },
          
            async confirmar() {

                        
                if (this.tipoContato== null  ) {
                    this.$buefy.dialog.alert({
                        title: this.$t('SISTEMA.ATENCAO'),
                        message: this.$t('MODALINSERIRNOVAASTEC.MENSAGEMTIPOCONTATO'),
                        type: 'is-warning',
                        hasIcon: true
                    });                    
                    return;
                }                   

                this.formData = new FormData(); 


                this.formData.append("novaAstecs.ClienteId", this.clienteId);
            

                this.formData.append("novaAstecs.Observacao", this.observacoes);
                this.formData.append("novaAstecs.TipoContato", this.tipoContato);
                this.formData.append("novaAstecs.UnidadeId", this.unidadeId);
                

                for(let i = 0; i < this.files.length;i++){
                    
                    this.formData.append('files', this.files[i]);                                                                                                              
                }

                   
                try {                                
                    this.$http.post(`/api/astecs/CriarNovaAstecs`,this.formData)
                    .then((res) => {
                        this.isLoading=false;

                        this.$buefy.toast.open({
                                duration: 5000,
                                message: this.$t("SISTEMA.SALVOSUCESSO"),
                                type: 'is-success'
                            });                           
                        
                    }).finally(() => {                                
                        this.isLoading = false;    
                        this.$emit('loadData')                            
                        this.$emit('close');   
                        this.$router.push({ name: 'astecs'});                                        
                    });                            

                    
                } catch (e) {
                    this.salvandoDados=false;                        
                    console.error(e);
                }
                                             

            },
            

        }
    }
</script>